module.exports = __webpack_public_path__ + "static/media/ninjacowLogo.71ea41ae.PNG";